export const lightTheme = {
    body: '#FFF',
    text: '#000',
   mainColor: '#00A878',
    background: '#ffffff',
    
}
export const darkTheme = {
    body: '#000',
    text: '#fff',
    mainColor: '#00A878',
    background: '#000000',
}